import { StepService } from './../../services/step/step.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { RecipeService } from 'src/app/services/recipe/recipe.service';
import * as CryptoJS from 'crypto-js';
import { Variables } from 'src/app/models/variables';

@Component({
  selector: 'app-session-value-trend',
  templateUrl: './session-value-trend.component.html',
  styleUrls: ['./session-value-trend.component.scss']
})
export class SessionValueTrendComponent implements OnInit {

  fromText = '';
  tillText = '';

  start = ' ';
  end = ' ';

  fromrange: any;
  tillrange: any;

  loading = false;
  recipes = [];
  recipe: any;

  steps = [];
  step: any;

  data: any;
  options: any;

  isvisible = false;
  isapply = false;

  constructor(
    private router: Router,
    public translate: TranslateService,
    private confirmationService: ConfirmationService,
    private cookieService: CookieService,
    private messageService: MessageService,
    private analyticsService: AnalyticsService,
    private recipeService: RecipeService,
    private stepService: StepService
  ) {
      this.translate.addLangs(['English', 'French']);
      this.translate.setDefaultLang('English');

      let browserLang = this.translate.getBrowserLang();

      const pass = 'ranitessarldev2019';
      const lang = cookieService.get('goepla-portal-language');
      if (lang.trim() !== '') {
        const declang = CryptoJS.AES.decrypt(lang, pass).toString(CryptoJS.enc.Utf8);
        const lg = declang;
        browserLang = lg;
        localStorage.setItem('language', lg);
      }

      if (localStorage.getItem('language') !== null) {
        browserLang = localStorage.getItem('language');
      }
      this.translate.use(browserLang.match(/English|French/) ? browserLang : 'English');

      this.translate.get('GENERAL.FROM').subscribe((resp: string) => {
        this.fromText = resp;
      });
      this.translate.get('GENERAL.TILL').subscribe((resp: string) => {
        this.tillText = resp;
      });
  }

  async ngOnInit() {
    const v = new Variables();
    const p = localStorage.getItem('ups');
    const val = CryptoJS.AES.decrypt(p, v.pass).toString(CryptoJS.enc.Utf8);
    const perm = JSON.parse(val);

    if ((perm !== undefined && perm !== null && perm.includes('DCM.Analytics.TestStepValueTrend'))
    || (perm !== undefined && perm !== null && perm.includes('DCM.Administration.Full'))) {
      this.isapply = true;
    }

    const frange = localStorage.getItem('filter-fromrange');
    const trange = localStorage.getItem('filter-tillrange');
    const frecipe = localStorage.getItem('filter-recipe');

    if (frange != null && trange != null && frecipe != null
        && frange !== undefined && trange !== undefined && frecipe !== undefined) {
      this.fromrange = new Date(frange);
      this.tillrange = new Date(trange);
      this.recipe = JSON.parse(frecipe);
    }

    await this.getRecipes();
    if (this.recipe !== undefined && this.recipe !== null) {
      await this.getSteps();
    }
  }

  async getSessionValues() {
    let upperlimit = '';
    let lowerlimit = '';
    let value = '';
    this.translate.get('GENERAL.UPPERLIMIT').subscribe((resp: string) => {
      upperlimit = resp;
    });
    this.translate.get('GENERAL.LOWERLIMIT').subscribe((resp: string) => {
      lowerlimit = resp;
    });
    this.translate.get('GENERAL.VALUE').subscribe((resp: string) => {
      value = resp;
    });
    this.loading = true;
    const sess = await this.analyticsService.getAnalyticsSessionValues(this.step.step_nr, this.recipe.rcp_id,
       this.start, this.end)
    .toPromise().catch(err => this.handleError(err));

    if (sess !== null && sess.length > 0) {
      let count = 0;
      const labs: string[] = [];
      const datasets: number[] = [];
      const datasets0: number[] = [];
      const datasets2: number[] = [];
      for (const ss of sess) {
        datasets0.push(this.step.ll);
        datasets.push(ss.val);
        datasets2.push(this.step.ul);
        const options: any = { year: 'numeric', month: 'short', day: 'numeric' };
        const d = new Date(new Date(ss.sess_start.toString().replace('T', ' ') + ' UTC')).toLocaleString('en-US', options);
        const t = new Date(new Date(ss.sess_start.toString().replace('T', ' ') + ' UTC')).toLocaleString('en-US', { hour12: false });
        const spl = t.split(',');
        const time = d + ',' + spl[1];
        labs.push(time);
        count += 1;

        if (count === sess.length) {
          this.data = {
            labels: labs,
            datasets: [
            {
                label: lowerlimit,
                backgroundColor: 'red',
                borderColor: 'red',
                data: datasets0,
                fill: false,
            },
            {
                label: value,
                backgroundColor: 'green',
                borderColor: 'green',
                data: datasets,
                fill: false,
            },
            {
                label: upperlimit,
                backgroundColor: 'red',
                borderColor: 'red',
                data: datasets2,
                fill: false,
            }
            ]
          };
          this.options = {
            title: {
                display: true,
                text: this.step.step_id,
                fontSize: 16
            },
            legend: {
                position: 'bottom',
                display: false
            },
            scales: {
              yAxes: [{
                  ticks: {
                      // beginAtZero: true
                  }
              }]
          }
          };
        }
      }

      this.isvisible = true;
      this.loading = false;
    } else {
      this.loading = false;
      this.isvisible = false;
      this.translate.get('GENERAL.NODATA').subscribe((resp: string) => {
        this.translate.get('GENERAL.INFO').subscribe((info: string) => {
          this.showInfo(info, resp);
        });
      });
    }
  }

  async getRecipes() {
    this.loading = true;
    this.recipes = [];
    const reps = await this.recipeService.getRecipes(0, 0, 0, ' ', ' ').toPromise().catch(err => this.handleError(err));
    if (reps != null && reps.length > 0) {
      for (const rep of reps) {
        this.recipes.push({ label: rep.rcp_name, value: rep});
        if (this.recipe != null && this.recipe !== undefined && this.recipe.rcp_id === rep.rcp_id) {
          this.recipe = rep;
        }
      }
    } else {
    }
    this.loading = false;
  }

  async getSteps() {
    this.steps = [];
    this.loading = true;
    let page = 0;
    let run = true;
    while (run === true) {
      page += 1;

      const steps = await this.stepService.getSteps(page, 500, this.recipe.rcp_id, 0).toPromise()
      .catch(err => this.handleError(err));
      if (steps != null && steps.length > 0) {
        for (const step of steps) {
          this.steps.push({ label: step.step_id, value: step });
        }
      } else {
        run = false;
        if (page === 1) {
          this.translate.get('GENERAL.INFO').subscribe((info: string) => {
            this.translate.get('GENERAL.NOSTEPS').subscribe((resp: string) => {
              this.showInfo(info, resp);
            });
          });
        }
      }
    }
    this.loading = false;
  }

  async apply() {
    if (this.fromrange === undefined || this.fromrange === null || this.tillrange === undefined || this.tillrange === null) {
      this.translate.get('GENERAL.SELECTTIMERANGE').subscribe((res) => {
        this.confirm(res);
      });
      return;
    } else if (this.recipe === undefined || this.recipe === null) {
      this.translate.get('GENERAL.SELECTRECIPE').subscribe((res) => {
        this.confirm(res);
      });
      return;
    } else if (this.step === undefined || this.step === null) {
      this.translate.get('GENERAL.SELECTSTEP').subscribe((res) => {
        this.confirm(res);
      });
      return;
    } else {
      this.start = this.fromrange.toJSON().toString();
      this.end = this.tillrange.toJSON().toString();

      localStorage.setItem('filter-fromrange', this.fromrange.toString());
      localStorage.setItem('filter-tillrange', this.tillrange.toString());
      localStorage.setItem('filter-recipe', JSON.stringify(this.recipe));

      // call function here
      await this.getSessionValues();
    }
  }

  confirm(text) {
    this.confirmationService.confirm({
        message: text,
        accept: async () => {
            // Accept logic
        },
        reject: () => {
          // Reject logic
        }
    });
  }

  showSuccess(title, message) {
    this.messageService.add({ key: 'tc', severity: 'success', summary: title, detail: message });
  }

  showInfo(title, message) {
      this.messageService.add({ key: 'tc', severity: 'info', summary: title, detail: message });
  }

  showWarn(title, message) {
      this.messageService.add({ key: 'tc', severity: 'warn', summary: title, detail: message });
  }

  showError(title, message) {
      this.messageService.add({ key: 'tc', severity: 'error', summary: title, detail: message });
  }

  handleError(err) {
    this.loading = false;
    console.log(err);
  }

  test() {
    const now = new Date();
    this.fromrange = new Date(now.setFullYear(new Date().getFullYear() - 1));
    this.tillrange = new Date(now.setFullYear(new Date().getFullYear() + 1));
  }

}
